import React from "react";

const DummyContent = ({ initDescription }) => {
  return (
    <div>
      <p className="text-sm mt-5">{initDescription}</p>
    </div>
  );
};

export default DummyContent;
